"use strict";
/**
 * The `TLabel` translation-label primitive: the type, the `t()` constructor,
 * key derivation, and parameter substitution.
 *
 * `t()` interns `TLabel` instances by key so equality checks stay cheap and
 * translations have a stable identity. Nothing here touches a UI framework, so
 * a label can be built and formatted anywhere.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.EMPTY_OBJECT = void 0;
exports.t = t;
exports.labelToKey = labelToKey;
exports.formatString = formatString;
// Stable empty object — use instead of {} literals to avoid unnecessary
// re-renders
exports.EMPTY_OBJECT = Object.freeze({});
const labelCache = new Map();
function t(key, defaultText) {
    const cacheKey = key ?? defaultText;
    const cached = labelCache.get(cacheKey);
    if (cached) {
        return cached;
    }
    const label = {
        key: key,
        defaultText: defaultText,
        toString: () => defaultText,
    };
    labelCache.set(cacheKey, label);
    return label;
}
function labelToKey(label) {
    return label.key ?? label.defaultText;
}
function formatString(template, values) {
    return template.replace(/{([^}]+)}/g, (match, key) => values[key] ?? '');
}
//# sourceMappingURL=label.js.map